export const normalizeSplitBalance = (
  balance: number,
  legalEntityBalance?: number | null
) => {
  const legalEntityBalanceNormalized = legalEntityBalance ?? null;

  return {
    legalEntityBalance: legalEntityBalanceNormalized,
    // Суммарный баланс для UI — эквивалент старого merged balance
    balance: balance + (legalEntityBalanceNormalized ?? 0)
  };
};
